import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('../components/moblieComponent/index');
const lotteryDetail = () => import('../components/moblieComponent/lotteryDetail')
const helper = () => import('../components/moblieComponent/helper')

Vue.use(VueRouter)

const vueRouter = new VueRouter({
    mode: 'history',
    // base:process.env.BASE_URL,
    base: '/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/lotteryDetail',
            name: 'lotteryDetail',
            component: lotteryDetail,
            props(route) {
                return route.query || {}
            }
        },
        {
            path: '/helper',
            name: 'helper',
            component: helper
        },
        { path: "*", component: Home },
        { path: '/index.html', name: 'home', component: Home }
    ]
})

export default vueRouter;